import GifterLeaderboard from "@/components/GifterLeaderboard";
import { Crown } from "lucide-react";

export default function Leaderboard() {
  return (
    <div className="md:ml-60 min-h-screen pb-24 md:pb-12">
      <div className="max-w-3xl mx-auto px-6 pt-10 space-y-6">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF007F] mb-2">
            // hall.of.gifters
          </p>
          <h1
            className="font-display font-black text-4xl md:text-5xl mb-3 flex items-center gap-3 glitch"
            data-text="LEADERBOARD"
          >
            <Crown className="h-7 w-7 text-[#FFB800]" strokeWidth={2} fill="#FFB800" />
            LEADERBOARD
          </h1>
          <p className="text-white/40 text-sm font-mono">
            the biggest hearts on neo-sync. every boost counts.
          </p>
        </div>

        <GifterLeaderboard initialPeriod="week" compact={false} />
      </div>
    </div>
  );
}
